import './transitions/slideRight.styl'
import './transitions/slideLeft.styl'
import './transitions/slideBottom.styl'
import './transitions/slideTop.styl'
import './transitions/dropDown.styl'
import './transitions/dropUp.styl'

export default {
    dropDown: 'sidePanel-dropDown',
    dropUp: 'sidePanel-dropUp',
    slideTop: 'sidePanel-slideTop',
    slideBottom: 'sidePanel-slideBottom',
    slideRight: 'sidePanel-slideRight',
    slideLeft: 'sidePanel-slideLeft',
}
